const PropTypes = require('prop-types');

module.exports = {
  isAlertActive: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string
};
